export var ICON_ARROW_WIDTH = 32;
export var SCROLL_DIRECTIONS = { SCROLL_LEFT: 0, SCROLL_RIGHT: 1 };
export var FILTER_BUTTON_WIDTH = 266;
